import { Header } from "./Header";
import { SalesCard } from "./SalesCard";
import { dashBoardOptions } from "../../pages/dashboard/dashBoardOption";
import PermissionWrapper from "features/Permission/PermissionWrapper";
import { EmiCalculator } from "features/emiCalculator/EmiCalculator";

const SalesHubDashboard = () => {
  return (
    <div className="container mx-auto p-4 text-center">
      <Header
        title="Your Sales Hub"
        subtitle="Track Leads, Applications, and Daily Targets at a Glance"
      />
      <div className="grid grid-cols-2 gap-4 md:w-3/4 m-auto mt-6">
        {dashBoardOptions.map((props) => {
          if (props.requiredPermissions) {
            return (
              <PermissionWrapper
                key={props.linkTo}
                actions={props.requiredPermissions}
              >
                <SalesCard {...props} />
              </PermissionWrapper>
            );
          }
          return <SalesCard key={props.linkTo} {...props} />;
        })}
        <EmiCalculator />
      </div>
    </div>
  );
};

export default SalesHubDashboard;
